import http from '@/assets/js/interceptor';
export function getListDropdown(data) {
  return http.post('/v1/appBase/listDropdown', data);
}
